<template>
<nav>
    <v-snackbar v-model="snackbar" :timeout="4000" top color="success">
        <span>Booking oprettet</span>
        <v-btn flat color="white" @click="snackbar=false">Luk</v-btn>
    </v-snackbar>
    <!--        <v-snackbar v-model="versionbar" :timeout="10000" top color="red">
            <span>Der er en ny version af FoldPlan. Luk og åben app'en igen.</span>
            <v-btn flat color="white" @click="snackbar=false">Luk</v-btn>
        </v-snackbar> -->
    <v-snackbar v-model="$store.getters.showInstallOnIos" :timeout="10000" botton color="grey">
        <span>Installer FoldPlan som app. Klik på<img src="/img/icons/to-home-screen-white.png" width="18" height="18" />. Klik derefter på<v-icon class="white--text">add_box</v-icon>.</span>
        <v-btn flat color="white" @click="$store.dispatch('setShowInstallOnIos', false)">Luk</v-btn>
    </v-snackbar>
    <v-toolbar flat app>

        <v-toolbar-side-icon class="grey-text" @click="drawer = !drawer" v-if="!drawer"></v-toolbar-side-icon>
        <v-toolbar-title class="text-uppercase grey--text">

        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn flat small color="grey" v-if="userSession">
            <a @click="logout"><span class="caption grey--text" >Log ud</span>
                <v-icon right small class="grey--text">exit_to_app</v-icon></a>
        </v-btn>

    </v-toolbar>

    <v-navigation-drawer app v-model="drawer" class="light-blue darken-4" width="300">
        <v-container pa-1>
            <v-layout align-center justify-end row>
                <v-flex xs2 my-1 white--text>
                    <v-btn flat icon color="white" @click.stop="drawer = !drawer">
                        <v-icon>clear</v-icon>
                    </v-btn>

                </v-flex>
            </v-layout>
            <v-layout align-start justify-center row wrap text-xs-center>
                <v-flex xs12 white--text mb-1>
                    <span class="font-weight-light display-1">Fold</span>
                    <span class="font-weight-medium display-1" >Plan</span>
                </v-flex>
                <v-flex xs12 white--text mb-5 text-xs-center>
                    <span class="font-weight-bold subheading">Ballerup Rideklub</span>
                </v-flex>
            </v-layout>
            <v-spacer></v-spacer>
            <v-layout column align-center v-if="userSession">
                <v-flex mt-2>
                    <v-chip color="light-blue " text-color="white" @click="($router.push({ name: 'user'}))">
                        <v-avatar>
                            <v-icon>account_circle</v-icon>
                        </v-avatar>
                        {{name}}
                    </v-chip>
                </v-flex>

            </v-layout>
            <v-spacer></v-spacer>
            <v-layout column align-center v-if="userSession && approved" mt-4 mb-3>
                <v-flex>
                    <Popup button-type='large' @bookingAdded="snackbar = true" />
                </v-flex>
            </v-layout>
            <v-layout align-start justify-center row wrap text-md-center>
                <v-list>
                    <v-flex v-if="!userSession">
                        <v-list-tile v-for="link in linksPublic" :key="link.text" router :to="link.route" @click="showDrawer">
                            <v-list-tile-action v-if="!userSession">
                                <v-icon class="white--text">{{ link.icon }}</v-icon>
                            </v-list-tile-action>
                            <v-list-tile-content v-if="!userSession">
                                <v-list-tile-title class="white--text">{{ link.text }}</v-list-tile-title>
                            </v-list-tile-content>
                        </v-list-tile>
                    </v-flex>
                    <v-flex v-if="userSession">
                        <v-list-tile v-for="link in linksprivate" :key="link.text" router :to="link.route" @click="showDrawer">
                            <v-list-tile-action v-if="userSession">
                                <v-icon class="white--text">{{ link.icon }}</v-icon>
                            </v-list-tile-action>
                            <v-list-tile-content v-if="userSession">
                                <v-list-tile-title class="white--text">{{ link.text }}</v-list-tile-title>
                            </v-list-tile-content>
                        </v-list-tile>
                    </v-flex>
                    <v-flex v-if="isAdmin">
                        <v-list-tile v-for="link in linksadmin" :key="link.text" router :to="link.route" @click="showDrawer">
                            <v-list-tile-action v-if="isAdmin">
                                <v-icon class="white--text">{{ link.icon }}</v-icon>
                            </v-list-tile-action>
                            <v-list-tile-content v-if="isAdmin">
                                <v-list-tile-title class="white--text">{{ link.text }}</v-list-tile-title>
                            </v-list-tile-content>
                        </v-list-tile>
                    </v-flex>
                </v-list>
            </v-layout>
        </v-container>
    </v-navigation-drawer>
</nav>
</template>

<script>

import format from 'date-fns/format'
import Popup from './Popup'
import firebase from 'firebase'
export default {
    components: {
        Popup
    },
    data() {
        return {
            year: '',
            drawer: true,
            snackbar: false,
            linksPublic: [{
                    icon: 'person',
                    text: 'Login',
                    route: '/login'
                },
                {
                    icon: 'perm_identity',
                    text: 'Opret bruger',
                    route: '/signup'
                },
            ],
            linksprivate: [{
                    icon: 'dashboard',
                    text: 'Reservationer',
                    route: 'dashboard'
                },
                {
                    icon: 'person',
                    text: 'Min side',
                    route: '/user'
                },
                {
                    icon: 'warning',
                    text: 'Foldregler',
                    route: '/rules'
                },
            ],
            linksadmin: [{
                    icon: 'supervised_user_circle',
                    text: 'Admin brugere',
                    route: '/manageusers'
                },
                {
                    icon: 'dashboard',
                    text: 'Admin reservationer',
                    route: '/managebookings'
                },
                {
                    icon: 'cloud_download',
                    text: 'Export',
                    route: '/export'
                }                
            ]

        }
    },
    computed: {

        approved() {

            if (this.$store.getters.profile === null || this.$store.getters.profile == null || typeof this.$store.getters.profile === 'undefined')
                return false
            else {
                if (this.$store.getters.profile.approved)
                    return true
                else
                    return false
            }
        },
        users() {
            return this.$store.getters.users
        },
        userid() {
            if (this.$store.getters.authUser === null || this.$store.getters.authUser == null || typeof this.$store.getters.authUser === 'undefined')
                return ''
            else
                return this.$store.store.getters.authUser.uid

        },
        name() {
            if (this.$store.getters.profile === null || this.$store.getters.profile == null || typeof this.$store.getters.profile === 'undefined')
                return ''
            else
                return this.$store.getters.profile.name
        },
        profile() {
            return this.$store.getters.profile
        },
        userSession() {
            //console.log('#Navbar  userSession' + this.$store.getters.userSession)
            if (this.$store.getters.userSession)
                return true
            else
                return false
        },
        isAdmin() {
            if (this.userSession) {
                //console.log('outside if this.$store.getters.profile' + this.$store.getters.profile)
                if (this.$store.getters.profile !== null && this.$store.getters.profile != null && typeof this.$store.getters.profile !== 'undefined') {
                    //console.log('inside if this.$store.getters.profile' + this.$store.getters.profile)
                    if (this.$store.getters.profile.admin)
                        return true
                    else
                        return false
                }
            }
            return false
        },

    },
    created() {
        this.showInstallOnIos(),
            this.year = format(Date.now(), 'YYYY')
        //this.$store.dispatch('setNewVersion')
    },
    methods: {
        showDrawer() {
            if (this.$vuetify.breakpoint.name === 'xs' || this.$vuetify.breakpoint.name === 'sm')
                this.drawer = !this.drawer
        },
        userName(users, userid) {
            let user = []
            user = this.userById(users, userid)
            if (typeof user !== 'undefined') {
                return user.name
            } else {
                return ''
            }
        },
        userById(users, useridToFind) {
            const user = users.find(function (user) {
                return user.id === useridToFind;
            })
            return user
        },
        logout() {
            firebase.auth().signOut().then(() => {
                this.$store.dispatch('setAuthUser')
                this.$store.dispatch('setProfile', {
                    vm: this
                })
                this.$router.push({
                    name: 'login'
                })
            })
        },
        showInstallOnIos() {
            // Detects if device is on iOS 
            //this.$store.dispatch('setShowInstallOnIos', true)
            const isIos = () => {
                const userAgent = window.navigator.userAgent.toLowerCase();
                return /iphone|ipad|ipod/.test(userAgent);
            }
            // Detects if device is in standalone mode
            const isInStandaloneMode = () => ('standalone' in window.navigator) && (window.navigator.standalone);

            // Checks if should display install popup notification:
            if (isIos() && !isInStandaloneMode()) {
                this.$store.dispatch('setShowInstallOnIos', true)
            }

        }

    }
}
</script>
<style>
.primary {
    background-color: #1976d2 !important;
    border-color: #1976d2 !important;
}
</style>